function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconhistoryizin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.604 474.74H159.008a21.49 21.49 0 0 1-15.21-6.308L91.689 416.24a21.494 21.494 0 0 1-6.283-15.186V59.46a4.3 4.3 0 0 1 4.299-4.299h305.9a4.3 4.3 0 0 1 4.299 4.299v410.981a4.3 4.3 0 0 1-4.3 4.299z",
    style: {},
    fill: "#AEE0F4",
    "data-original": "#aee0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.081 29.687c0-12.522-10.374-22.621-22.996-22.172-12.023.427-21.378 10.674-21.378 22.704v14.276h44.373V29.687z",
    style: {},
    fill: "#FBC96D",
    "data-original": "#fbc96d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.397 97.577 6.888 398.682c0 2.38-1.92 4.3-4.3 4.3l-32.053 3.942h-185.76c-2.89 0-5.71-.62-8.29-1.8l-4.302-67.618c0-2.21-1.79-4-4-4l-70.138-6.922c-1.18-2.57-1.8-5.4-1.8-8.28V89.22c0-2.37 1.93-4.3 4.3-4.3h287.2l7.955 8.357a4.3 4.3 0 0 1 4.3 4.3z",
    style: {},
    fill: "#DFF8FF",
    "data-original": "#dff8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.883 428.16v74.54c-2.17-.98-4.15-2.36-5.86-4.07l-68.53-68.61a19.97 19.97 0 0 1-4.05-5.86h74.44c2.21 0 4 1.79 4 4z",
    style: {},
    fill: "#AEE0F4",
    "data-original": "#aee0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.388 101.598H143.4a4 4 0 0 1-4-4V52.209c0-8.284 6.716-15 15-15h116.987c8.284 0 15 6.716 15 15v45.388a3.999 3.999 0 0 1-3.999 4.001z",
    style: {},
    fill: "#FFDA8F",
    "data-original": "#ffda8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.843 84.92h-18.7v117.968l19.143 84.706-19.143 34.796v160.05c0 12.18-9.88 22.06-22.06 22.06h40.76a4.3 4.3 0 0 0 4.3-4.3V89.22a4.3 4.3 0 0 0-4.3-4.3z",
    style: {},
    fill: "#C0ECFC",
    "data-original": "#c0ecfc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.599,
    cy: 299.39,
    r: 55.196,
    style: {},
    fill: "#52D8A4",
    "data-original": "#52d8a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.376 188.049h-178.97a3 3 0 0 1-3-3v-40.452a3 3 0 0 1 3-3h178.97a3 3 0 0 1 3 3v40.452a3 3 0 0 1-3 3z",
    style: {},
    fill: "#AEE0F4",
    "data-original": "#aee0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.079 338.844.128 34.361a5.34 5.34 0 0 1-5.339 5.339l-27.235 3.412h-88.299a5.339 5.339 0 0 1-5.339-5.339v-38.589l126.084.816z",
    style: {},
    fill: "#FFDA8F",
    "data-original": "#ffda8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.74 338.842v37.776a5.337 5.337 0 0 1-5.339 5.339h-30.768v-43.342l36.107.227z",
    style: {},
    fill: "#FBC96D",
    "data-original": "#fbc96d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.726 308.883 3.149-47.681a88.227 88.227 0 0 1 7.635-35.903c5.034-11.3 9.199-23.269 9.199-35.639v-5.603c0-22.765-12.914-37.614-35.679-37.614-4.671 0-14.511-1.111-14.511-1.111-16.214 5.546-27.87 20.924-27.87 39.018v5.603a88.227 88.227 0 0 0 7.635 35.903c.139.311.276.623.41.936 8.833 4.012 11.596 12.303 5.95 20.026a88.198 88.198 0 0 1 1.274 14.941v47.124h42.808z",
    style: {},
    fill: "#D37F66",
    "data-original": "#d37f66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.087 184.348v5.606a88.04 88.04 0 0 1-1.936 18.354 88.063 88.063 0 0 1-5.7 17.553c-.138.31-.274.62-.408.931-10.342 5.455-12.038 10.983-5.946 19.984a88.212 88.212 0 0 0-1.281 14.979v47.133H380.12v-47.133a88.174 88.174 0 0 1 7.635-35.893 88.148 88.148 0 0 0 5.7-17.553 88.108 88.108 0 0 0 1.936-18.354v-5.606c0-18.087-11.653-33.464-27.871-39.017a41.29 41.29 0 0 1 13.348-2.202c22.772-.001 41.219 18.46 41.219 41.218z",
    style: {},
    fill: "#C17467",
    "data-original": "#c17467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.363 343.368-38.73 2.023h-98.915a5.34 5.34 0 0 1-5.339-5.339v-12.76c0-15.41 12.492-27.902 27.902-27.902h53.146l40.453 1.828c15.41 0 26.759 11.852 26.759 27.262l.063 9.548a5.338 5.338 0 0 1-5.339 5.34z",
    style: {},
    fill: "#DD8D6B",
    "data-original": "#dd8d6b",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.352 327.296v12.761a5.337 5.337 0 0 1-5.339 5.339h-41.38v-18.1c0-15.417-12.481-27.911-27.898-27.911h46.719c15.417-.001 27.898 12.493 27.898 27.911z",
    style: {},
    fill: "#D37F66",
    "data-original": "#d37f66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.245 270.846h116.782M236.245 313.021h68.556M445.739 347.323v30.634a4 4 0 0 1-4 4H319.992a4 4 0 0 1-4-4v-30.054M420.93 345.39h31.43c2.2 0 4-1.79 4-4v-21.1c0-11.54-9.36-20.9-20.91-20.9H326.28c-11.54 0-20.9 9.36-20.9 20.9v21.1c0 2.21 1.79 4 4 4h76.55M406.815 297.194v-35.435a88.227 88.227 0 0 1 7.635-35.903v0a88.23 88.23 0 0 0 7.635-35.903v-5.603c0-22.765-18.455-41.219-41.219-41.219h0c-22.765 0-41.219 18.455-41.219 41.219v5.603a88.227 88.227 0 0 0 7.635 35.903v0a88.23 88.23 0 0 1 7.635 35.903v35.435M354.027 236.806h56.391M123.841 300.419l19.341 20.059 34.176-34.175",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.599,
    cy: 299.39,
    r: 55.196,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.406 141.598h184.97v46.452h-184.97zM186.141 412.751l1.73-1.49c9.295-8.007 23.755-3.784 27.28 7.967h0a49.385 49.385 0 0 1-5.273 40.122h0a13.62 13.62 0 0 1-16.712 5.469h0c-6.843-2.777-9.407-11.14-5.296-17.276h0a44.986 44.986 0 0 1 26.336-18.571l22.549-5.708a4.48 4.48 0 0 1 4.969 2.086l6.345 10.877c2.202 3.774 7.647 3.797 9.881.042l11.436-19.23c1.173-1.973 4.011-2.025 5.256-.097l6.972 10.792c7.548 11.684 23.37 14.613 34.601 6.406l3.356-2.453M85.403 83.258V59.46a4.3 4.3 0 0 1 4.299-4.299h48.583M399.9 383.323v87.118a4.3 4.3 0 0 1-4.299 4.299h-23.639M361.11 55.16h34.49a4.3 4.3 0 0 1 4.3 4.3v87.15M326.11 55.16h-38.79M235.078 35.774v-6.087c0-12.253-9.933-22.187-22.187-22.187-12.253 0-22.187 9.933-22.187 22.187v5.958M55.64 118.63V89.22c0-2.37 1.93-4.3 4.3-4.3h78.35",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14 383.32V500.2c0 2.38-1.92 4.3-4.3 4.3H208.2M55.64 153.63v262.25c0 5.3 2.11 10.39 5.85 14.14l68.53 68.61a19.98 19.98 0 0 0 14.15 5.87h29.03M287.834 84.922h78.008a4.3 4.3 0 0 1 4.299 4.299v53.908M282.385 101.598H143.398a4 4 0 0 1-4-4V52.209c0-8.284 6.716-15 15-15h116.987c8.284 0 15 6.716 15 15v45.388a4 4 0 0 1-4 4.001z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.877 501.172v-77.011h-77.01",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: "15px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhistoryizin);
export default __webpack_public_path__ + "static/media/iconhistoryizin.6067e55ea36a76b0675279d9ba43c125.svg";
export { ForwardRef as ReactComponent };